import styled from "@emotion/styled"
import React from 'react'
import {Colors} from '../../styles/colors'
import {Typography} from '../../styles/typography'
import {LENS_ENUM} from '../../utils/blog/const'

export const LENS_SIZES = {
  small: 'small',
  medium: 'medium'
}

export const LENSES_MAP = {
  [LENS_ENUM.COME_FARE]: {
    title: 'Come fare a',
    backgroundColor: Colors.BackgroundColor.royalPurple500
  },
  [LENS_ENUM.INCENTIVI]: {
    title: 'Incentivi',
    backgroundColor: Colors.BackgroundColor.turquoiseBlue500
  },
  [LENS_ENUM.NOVITA]: {
    title: 'Novità',
    backgroundColor: Colors.BackgroundColor.marigold500
  },
  [LENS_ENUM.VIDEO]: {
    title: 'Video',
    backgroundColor: Colors.BackgroundColor.marigold500
  },
  [LENS_ENUM.VOCE_ESPERTO]: {
    title: 'Voce dell\'esperto',
    backgroundColor: Colors.BackgroundColor.vibrantPurple500
  },
}


const LensContainer = styled.div`
  padding: 4px 8px;
  border-radius: 4px;

  &[data-type='${LENS_SIZES.small}'] {
    padding: 2px 4px;
  }

`

export const Lens = ({type = LENS_ENUM.NOVITA, size = LENS_SIZES.medium}) => {
  if (!LENSES_MAP[type]) {
    return null
  }
  
  const {title, backgroundColor} = LENSES_MAP[type]
  const typography = {
    [LENS_SIZES.medium]: Typography.label.label2_400,
    [LENS_SIZES.small]: Typography.label.label4_400
  }[size]

  return <LensContainer data-type={size} css={backgroundColor}>
    <div css={[Colors.Color.eerieBlack0, typography]}>{title}</div>
  </LensContainer>
}
